import { ComponentPropsWithoutRef, forwardRef, isValidElement, memo, ReactElement } from "react"

type SVGProps = ComponentPropsWithoutRef<"svg">

export const Icon0 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM10.265 15.513C10.683 15.821 11.1817 15.975 11.761 15.975C12.333 15.975 12.828 15.8137 13.246 15.491C13.664 15.1683 13.983 14.7063 14.203 14.105C14.4303 13.4963 14.544 12.774 14.544 11.938C14.544 11.102 14.4377 10.3907 14.225 9.804C14.0123 9.21733 13.7007 8.77 13.29 8.462C12.8793 8.154 12.3843 8 11.805 8C11.233 8 10.7343 8.16133 10.309 8.484C9.891 8.80667 9.56833 9.26867 9.341 9.87C9.11367 10.4713 9 11.1827 9 12.004C9 12.8473 9.10633 13.566 9.319 14.16C9.539 14.754 9.85433 15.205 10.265 15.513ZM12.421 14.479C12.245 14.6917 12.0323 14.798 11.783 14.798C11.5263 14.798 11.3063 14.6953 11.123 14.49C10.947 14.2773 10.8113 13.962 10.716 13.544C10.628 13.126 10.584 12.6053 10.584 11.982C10.584 11.3733 10.6317 10.86 10.727 10.442C10.8223 10.024 10.958 9.70867 11.134 9.496C11.31 9.276 11.5263 9.166 11.783 9.166C12.0397 9.166 12.2523 9.27233 12.421 9.485C12.597 9.69767 12.729 10.013 12.817 10.431C12.9123 10.849 12.96 11.3623 12.96 11.971C12.96 12.5943 12.9123 13.115 12.817 13.533C12.729 13.951 12.597 14.2663 12.421 14.479Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon1 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM11.4859 9.70919L9.8689 10.079V8.979L12.1019 8H12.9819V14.49H14.4339V15.7H9.9129V14.49H11.4859V9.70919Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon10 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.625 4.875H4.875V18.625H18.625V4.875ZM4.875 3H18.625H20.5V4.875V18.625V20.5H18.625H4.875H3V18.625V4.875V3H4.875ZM14.2593 15.975C13.68 15.975 13.1813 15.821 12.7633 15.513C12.3526 15.205 12.0373 14.754 11.8173 14.16C11.6046 13.566 11.4983 12.8473 11.4983 12.004C11.4983 11.1827 11.612 10.4713 11.8393 9.87C12.0666 9.26867 12.3893 8.80667 12.8073 8.484C13.2326 8.16133 13.7313 8 14.3033 8C14.8826 8 15.3776 8.154 15.7883 8.462C16.199 8.77 16.5106 9.21733 16.7233 9.804C16.936 10.3907 17.0423 11.102 17.0423 11.938C17.0423 12.774 16.9286 13.4963 16.7013 14.105C16.4813 14.7063 16.1623 15.1683 15.7443 15.491C15.3263 15.8137 14.8313 15.975 14.2593 15.975ZM14.2813 14.798C14.5306 14.798 14.7433 14.6917 14.9193 14.479C15.0953 14.2663 15.2273 13.951 15.3153 13.533C15.4106 13.115 15.4583 12.5943 15.4583 11.971C15.4583 11.3623 15.4106 10.849 15.3153 10.431C15.2273 10.013 15.0953 9.69767 14.9193 9.485C14.7506 9.27233 14.538 9.166 14.2813 9.166C14.0246 9.166 13.8083 9.276 13.6323 9.496C13.4563 9.70867 13.3206 10.024 13.2253 10.442C13.13 10.86 13.0823 11.3733 13.0823 11.982C13.0823 12.6053 13.1263 13.126 13.2143 13.544C13.3096 13.962 13.4453 14.2773 13.6213 14.49C13.8046 14.6953 14.0246 14.798 14.2813 14.798ZM8.4859 9.84127L6.8689 10.2111V9.11108L9.1019 8.13208H9.9819V14.6221H11.4339V15.8321H6.9129V14.6221H8.4859V9.84127Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon12 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.625 4.875H4.875V18.625H18.625V4.875ZM4.875 3H18.625H20.5V4.875V18.625V20.5H18.625H4.875H3V18.625V4.875V3H4.875ZM11.9374 14.831L13.9284 12.642C14.3024 12.2533 14.5884 11.9307 14.7864 11.674C14.9844 11.41 15.1238 11.168 15.2044 10.948C15.2851 10.728 15.3254 10.4897 15.3254 10.233C15.3254 10.0057 15.2814 9.81133 15.1934 9.65C15.1128 9.48867 14.9918 9.364 14.8304 9.276C14.6764 9.188 14.4894 9.144 14.2694 9.144C13.9101 9.144 13.6278 9.24667 13.4224 9.452C13.2171 9.65733 13.0778 9.98367 13.0044 10.431L11.7834 10.167C11.9008 9.43367 12.1794 8.891 12.6194 8.539C13.0594 8.17967 13.6351 8 14.3464 8C14.8671 8 15.3071 8.08433 15.6664 8.253C16.0258 8.42167 16.2971 8.66733 16.4804 8.99C16.6711 9.31267 16.7664 9.70133 16.7664 10.156C16.7664 10.486 16.7114 10.805 16.6014 11.113C16.4914 11.4137 16.3118 11.729 16.0624 12.059C15.8131 12.389 15.4794 12.7593 15.0614 13.17C14.9441 13.2727 14.8561 13.3533 14.7974 13.412L13.647 14.611H16.9314V15.832H11.9374V14.831ZM8.617 9.84127L7 10.2111V9.11108L9.233 8.13208H10.113V14.6221H11.565V15.8321H7.044V14.6221H8.617V9.84127Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon14 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.625 4.875H4.875V18.625H18.625V4.875ZM4.875 3H18.625H20.5V4.875V18.625V20.5H18.625H4.875H3V18.625V4.875V3H4.875ZM11.3884 13.148L14.5234 8H16.1514V12.906H17.0864V14.072H16.1514V15.7H14.7434V14.072H11.3884V13.148ZM12.7752 12.906L14.7434 9.67V12.906H12.7752ZM8.4859 9.70919L6.8689 10.079V8.979L9.1019 8H9.9819V14.49H11.4339V15.7H6.9129V14.49H8.4859V9.70919Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon18 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.625 4.875H4.875V18.625H18.625V4.875ZM4.875 3H18.625H20.5V4.875V18.625V20.5H18.625H4.875H3V18.625V4.875V3H4.875ZM14.3464 15.975C13.8184 15.975 13.3601 15.8943 12.9714 15.733C12.5901 15.5717 12.2968 15.3407 12.0914 15.04C11.8861 14.732 11.7834 14.369 11.7834 13.951C11.7834 13.6357 11.8494 13.3387 11.9814 13.06C12.1208 12.7813 12.3151 12.543 12.5644 12.345C12.7191 12.2177 12.8906 12.1072 13.0791 12.0137C12.9983 11.9648 12.9221 11.9139 12.8504 11.861C12.5424 11.6337 12.3151 11.377 12.1684 11.091C12.0291 10.805 11.9594 10.486 11.9594 10.134C11.9594 9.70133 12.0584 9.32733 12.2564 9.012C12.4544 8.68933 12.7404 8.44 13.1144 8.264C13.4958 8.088 13.9431 8 14.4564 8C14.9551 8 15.3804 8.077 15.7324 8.231C16.0918 8.385 16.3668 8.60867 16.5574 8.902C16.7481 9.19533 16.8434 9.54733 16.8434 9.958C16.8434 10.2367 16.7848 10.497 16.6674 10.739C16.5574 10.981 16.3961 11.201 16.1834 11.399C16.0493 11.5193 15.8962 11.6264 15.7241 11.7204C15.8731 11.7992 16.0078 11.8827 16.1284 11.971C16.4291 12.1837 16.6528 12.4367 16.7994 12.73C16.9461 13.016 17.0194 13.346 17.0194 13.72C17.0194 14.1747 16.9094 14.5707 16.6894 14.908C16.4768 15.2453 16.1688 15.5093 15.7654 15.7C15.3621 15.8833 14.8891 15.975 14.3464 15.975ZM13.9834 10.981C14.1667 11.0865 14.3984 11.1921 14.6784 11.2976C14.818 11.212 14.9383 11.1211 15.0394 11.025C15.1934 10.8857 15.3071 10.7353 15.3804 10.574C15.4538 10.4127 15.4904 10.2403 15.4904 10.057C15.4904 9.771 15.3951 9.54367 15.2044 9.375C15.0138 9.20633 14.7461 9.122 14.4014 9.122C14.1814 9.122 13.9871 9.15867 13.8184 9.232C13.6571 9.30533 13.5324 9.408 13.4444 9.54C13.3638 9.672 13.3234 9.82967 13.3234 10.013C13.3234 10.211 13.3748 10.387 13.4774 10.541C13.5801 10.695 13.7488 10.8417 13.9834 10.981ZM14.1286 12.4673C13.9615 12.554 13.8141 12.6489 13.6864 12.752C13.5031 12.8987 13.3638 13.0637 13.2684 13.247C13.1804 13.4303 13.1364 13.6283 13.1364 13.841C13.1364 14.1563 13.2464 14.4057 13.4664 14.589C13.6938 14.765 14.0018 14.853 14.3904 14.853C14.7864 14.853 15.0944 14.765 15.3144 14.589C15.5344 14.413 15.6444 14.171 15.6444 13.863C15.6444 13.6503 15.5968 13.4633 15.5014 13.302C15.4061 13.1407 15.2411 12.9903 15.0064 12.851C14.7911 12.7231 14.4984 12.5952 14.1286 12.4673ZM8.617 9.84127L7 10.2111V9.11108L9.233 8.13208H10.113V14.6221H11.565V15.8321H7.044V14.6221H8.617V9.84127Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon2 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM11.145 12.642L9.154 14.831V15.832H14.148V14.611H10.8635L12.014 13.412C12.0727 13.3533 12.1607 13.2727 12.278 13.17C12.696 12.7593 13.0297 12.389 13.279 12.059C13.5283 11.729 13.708 11.4137 13.818 11.113C13.928 10.805 13.983 10.486 13.983 10.156C13.983 9.70133 13.8877 9.31267 13.697 8.99C13.5137 8.66733 13.2423 8.42167 12.883 8.253C12.5237 8.08433 12.0837 8 11.563 8C10.8517 8 10.276 8.17967 9.836 8.539C9.396 8.891 9.11733 9.43367 9 10.167L10.221 10.431C10.2943 9.98367 10.4337 9.65733 10.639 9.452C10.8443 9.24667 11.1267 9.144 11.486 9.144C11.706 9.144 11.893 9.188 12.047 9.276C12.2083 9.364 12.3293 9.48867 12.41 9.65C12.498 9.81133 12.542 10.0057 12.542 10.233C12.542 10.4897 12.5017 10.728 12.421 10.948C12.3403 11.168 12.201 11.41 12.003 11.674C11.805 11.9307 11.519 12.2533 11.145 12.642Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon3 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM9.902 15.502C10.3493 15.8173 10.9213 15.975 11.618 15.975C12.1533 15.975 12.619 15.8797 13.015 15.689C13.4183 15.4983 13.73 15.227 13.95 14.875C14.1773 14.5157 14.291 14.0903 14.291 13.599C14.291 13.225 14.225 12.895 14.093 12.609C13.961 12.3157 13.7667 12.0773 13.51 11.894C13.3768 11.796 13.2289 11.7169 13.0664 11.6567C13.1376 11.6145 13.2048 11.569 13.268 11.52C13.5027 11.344 13.6787 11.1277 13.796 10.871C13.9207 10.6143 13.983 10.332 13.983 10.024C13.983 9.59867 13.8913 9.23567 13.708 8.935C13.5247 8.63433 13.257 8.40333 12.905 8.242C12.553 8.08067 12.1277 8 11.629 8C10.8957 8 10.3127 8.18333 9.88 8.55C9.44733 8.90933 9.176 9.43733 9.066 10.134L10.265 10.398C10.331 9.98 10.463 9.66833 10.661 9.463C10.859 9.25033 11.1413 9.144 11.508 9.144C11.7353 9.144 11.926 9.18433 12.08 9.265C12.234 9.34567 12.3477 9.46667 12.421 9.628C12.5017 9.782 12.542 9.97267 12.542 10.2C12.542 10.552 12.4467 10.8233 12.256 11.014C12.0653 11.2047 11.794 11.3 11.442 11.3H10.936V12.477H11.618C12.0067 12.477 12.3037 12.576 12.509 12.774C12.7217 12.9647 12.828 13.2397 12.828 13.599C12.828 13.8557 12.7803 14.0757 12.685 14.259C12.597 14.4423 12.4613 14.5853 12.278 14.688C12.102 14.7833 11.882 14.831 11.618 14.831C11.3833 14.831 11.1743 14.7907 10.991 14.71C10.815 14.622 10.6647 14.4937 10.54 14.325C10.4153 14.149 10.3163 13.929 10.243 13.665L9 14.072C9.154 14.71 9.45467 15.1867 9.902 15.502Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon4 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM12.135 8L9 13.148V14.072H12.355V15.7H13.763V14.072H14.698V12.906H13.763V8H12.135ZM12.355 9.67L10.3868 12.906H12.355V9.67Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon5 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM10.8371 15.645C11.1745 15.777 11.5595 15.843 11.9921 15.843C12.5275 15.843 12.9931 15.7367 13.3891 15.524C13.7851 15.304 14.0931 14.9923 14.3131 14.589C14.5331 14.1857 14.6431 13.7163 14.6431 13.181C14.6431 12.6603 14.5551 12.213 14.3791 11.839C14.2105 11.4577 13.9538 11.168 13.6091 10.97C13.2718 10.772 12.8575 10.673 12.3661 10.673C12.0288 10.673 11.7245 10.7243 11.4531 10.827C11.2679 10.8921 11.0929 10.9845 10.9282 11.1043L11.029 9.254H14.2141V8H9.90212L9.68212 12.158L10.8041 12.499C10.9581 12.2863 11.1341 12.125 11.3321 12.015C11.5301 11.905 11.7648 11.85 12.0361 11.85C12.4101 11.85 12.6925 11.971 12.8831 12.213C13.0811 12.4477 13.1801 12.785 13.1801 13.225C13.1801 13.533 13.1361 13.797 13.0481 14.017C12.9601 14.2297 12.8245 14.3983 12.6411 14.523C12.4651 14.6403 12.2488 14.699 11.9921 14.699C11.6548 14.699 11.3798 14.611 11.1671 14.435C10.9545 14.259 10.8005 13.984 10.7051 13.61L9.49512 13.995C9.59778 14.4203 9.76278 14.7687 9.99012 15.04C10.2175 15.3113 10.4998 15.513 10.8371 15.645Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon6 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM10.276 15.535C10.694 15.8283 11.211 15.975 11.827 15.975C12.3183 15.975 12.7583 15.8687 13.147 15.656C13.543 15.436 13.8473 15.128 14.06 14.732C14.28 14.336 14.39 13.885 14.39 13.379C14.39 12.9097 14.3093 12.499 14.148 12.147C13.9867 11.795 13.7447 11.5237 13.422 11.333C13.1067 11.135 12.7253 11.036 12.278 11.036C11.9847 11.036 11.7097 11.08 11.453 11.168C11.1963 11.256 10.9543 11.3917 10.727 11.575C10.668 11.6222 10.6106 11.6734 10.5547 11.7285C10.5676 11.191 10.614 10.7438 10.694 10.387C10.7967 9.96167 10.9433 9.65367 11.134 9.463C11.3247 9.27233 11.5593 9.177 11.838 9.177C12.014 9.177 12.1643 9.21733 12.289 9.298C12.421 9.37867 12.531 9.50333 12.619 9.672C12.707 9.83333 12.7767 10.035 12.828 10.277L14.126 10.002C14.0747 9.57667 13.95 9.21367 13.752 8.913C13.5613 8.61233 13.3047 8.385 12.982 8.231C12.6593 8.077 12.2817 8 11.849 8C11.2623 8 10.7527 8.16133 10.32 8.484C9.89467 8.79933 9.56833 9.265 9.341 9.881C9.11367 10.497 9 11.2303 9 12.081C9 12.9317 9.10633 13.6467 9.319 14.226C9.539 14.798 9.858 15.2343 10.276 15.535ZM10.5845 12.9184C10.6732 12.7974 10.7647 12.6943 10.859 12.609C11.0203 12.4623 11.1853 12.3597 11.354 12.301C11.5227 12.2423 11.7023 12.213 11.893 12.213C12.1203 12.213 12.311 12.268 12.465 12.378C12.6263 12.4807 12.7473 12.631 12.828 12.829C12.9087 13.0197 12.949 13.247 12.949 13.511C12.949 13.7823 12.905 14.017 12.817 14.215C12.7363 14.413 12.6153 14.567 12.454 14.677C12.3 14.787 12.113 14.842 11.893 14.842C11.585 14.842 11.332 14.7467 11.134 14.556C10.9433 14.3653 10.7967 14.0647 10.694 13.654C10.6448 13.442 10.6083 13.1968 10.5845 12.9184Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon7 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM10.639 13.236C10.4923 14.0133 10.419 14.8347 10.419 15.7H12.014V15.601C12.0213 14.5963 12.0763 13.7273 12.179 12.994C12.289 12.2607 12.498 11.5603 12.806 10.893C13.1213 10.2183 13.5723 9.54733 14.159 8.88V8H9V9.254H12.5261C12.0656 9.79703 11.6896 10.369 11.398 10.97C11.0387 11.7033 10.7857 12.4587 10.639 13.236Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon8 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM10.188 15.733C10.5767 15.8943 11.035 15.975 11.563 15.975C12.1057 15.975 12.5787 15.8833 12.982 15.7C13.3853 15.5093 13.6933 15.2453 13.906 14.908C14.126 14.5707 14.236 14.1747 14.236 13.72C14.236 13.346 14.1627 13.016 14.016 12.73C13.8693 12.4367 13.6457 12.1837 13.345 11.971C13.2244 11.8827 13.0896 11.7992 12.9407 11.7204C13.1128 11.6264 13.2659 11.5193 13.4 11.399C13.6127 11.201 13.774 10.981 13.884 10.739C14.0013 10.497 14.06 10.2367 14.06 9.958C14.06 9.54733 13.9647 9.19533 13.774 8.902C13.5833 8.60867 13.3083 8.385 12.949 8.231C12.597 8.077 12.1717 8 11.673 8C11.1597 8 10.7123 8.088 10.331 8.264C9.957 8.44 9.671 8.68933 9.473 9.012C9.275 9.32733 9.176 9.70133 9.176 10.134C9.176 10.486 9.24567 10.805 9.385 11.091C9.53167 11.377 9.759 11.6337 10.067 11.861C10.1387 11.9139 10.2149 11.9648 10.2957 12.0137C10.1072 12.1072 9.93564 12.2177 9.781 12.345C9.53167 12.543 9.33733 12.7813 9.198 13.06C9.066 13.3387 9 13.6357 9 13.951C9 14.369 9.10267 14.732 9.308 15.04C9.51333 15.3407 9.80667 15.5717 10.188 15.733ZM11.895 11.2976C11.615 11.1921 11.3833 11.0865 11.2 10.981C10.9653 10.8417 10.7967 10.695 10.694 10.541C10.5913 10.387 10.54 10.211 10.54 10.013C10.54 9.82967 10.5803 9.672 10.661 9.54C10.749 9.408 10.8737 9.30533 11.035 9.232C11.2037 9.15867 11.398 9.122 11.618 9.122C11.9627 9.122 12.2303 9.20633 12.421 9.375C12.6117 9.54367 12.707 9.771 12.707 10.057C12.707 10.2403 12.6703 10.4127 12.597 10.574C12.5237 10.7353 12.41 10.8857 12.256 11.025C12.1548 11.1211 12.0345 11.212 11.895 11.2976ZM10.903 12.752C11.0307 12.6489 11.178 12.554 11.3451 12.4673C11.715 12.5952 12.0076 12.7231 12.223 12.851C12.4577 12.9903 12.6227 13.1407 12.718 13.302C12.8133 13.4633 12.861 13.6503 12.861 13.863C12.861 14.171 12.751 14.413 12.531 14.589C12.311 14.765 12.003 14.853 11.607 14.853C11.2183 14.853 10.9103 14.765 10.683 14.589C10.463 14.4057 10.353 14.1563 10.353 13.841C10.353 13.6283 10.397 13.4303 10.485 13.247C10.5803 13.0637 10.7197 12.8987 10.903 12.752Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon9 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM10.397 15.744C10.7343 15.898 11.1193 15.975 11.552 15.975C12.146 15.975 12.652 15.821 13.07 15.513C13.4953 15.205 13.818 14.7503 14.038 14.149C14.258 13.5403 14.368 12.796 14.368 11.916C14.368 11.0727 14.258 10.3613 14.038 9.782C13.818 9.19533 13.4953 8.75167 13.07 8.451C12.652 8.15033 12.1423 8 11.541 8C11.035 8 10.5877 8.11 10.199 8.33C9.81767 8.54267 9.52067 8.847 9.308 9.243C9.10267 9.63167 9 10.0863 9 10.607C9 11.0837 9.08433 11.5053 9.253 11.872C9.42167 12.2313 9.66367 12.51 9.979 12.708C10.3017 12.906 10.6867 13.005 11.134 13.005C11.5667 13.005 11.9443 12.9243 12.267 12.763C12.4659 12.659 12.648 12.5244 12.8135 12.3592C12.8008 12.8971 12.7544 13.3361 12.674 13.676C12.586 14.072 12.4503 14.3617 12.267 14.545C12.091 14.721 11.8563 14.809 11.563 14.809C11.277 14.809 11.0423 14.721 10.859 14.545C10.683 14.3617 10.5547 14.0793 10.474 13.698L9.154 13.984C9.22 14.4093 9.35933 14.7723 9.572 15.073C9.78467 15.3663 10.0597 15.59 10.397 15.744ZM12.7842 11.1963C12.6342 11.4093 12.4654 11.5686 12.278 11.674C12.0507 11.7987 11.794 11.861 11.508 11.861C11.2807 11.861 11.0863 11.8097 10.925 11.707C10.771 11.597 10.6537 11.4393 10.573 11.234C10.4923 11.0213 10.452 10.772 10.452 10.486C10.452 10.2073 10.4923 9.969 10.573 9.771C10.6537 9.56567 10.7747 9.41167 10.936 9.309C11.0973 9.199 11.288 9.144 11.508 9.144C11.8013 9.144 12.0433 9.254 12.234 9.474C12.432 9.68667 12.5787 10.0093 12.674 10.442C12.7237 10.6636 12.7604 10.915 12.7842 11.1963Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconArrowLeft = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M3.70312 12.9688L3.03906 12.3047L3.70312 11.6406L9.67969 5.66406L10.3438 5L11.6719 6.32812L11.0078 6.99219L6.63281 11.3672H19.5625H20.5V13.2422H19.5625H6.63281L11.0078 17.6562L11.6719 18.3203L10.3438 19.6484L9.67969 18.9844L3.70312 12.9688Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconArrowRight = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M19.7578 12.9688L13.7812 18.9844L13.1172 19.6484L11.7891 18.3203L12.4531 17.6562L16.8281 13.2422H3.9375H3V11.3672H3.9375H16.8281L12.4531 6.99219L11.7891 6.32812L13.1172 5L13.7812 5.66406L19.7578 11.6406L20.4219 12.3047L19.7578 12.9688Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconBookmark = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M11.5 14.9766L12.4375 15.5234L17.125 18.2578V3.375H5.875V18.2578L10.5234 15.5234L11.5 14.9766ZM5.875 20.4062L4 21.5V19.3516V3.375V1.5H5.875H17.125H19V3.375V19.3516V21.5L17.125 20.4062L11.5 17.125L5.875 20.4062Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconCalendar = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M8.9375 2.4375V4H14.5625V2.4375V1.5H16.4375V2.4375V4H20.5V7.125V9V19.625V21.5H18.625H4.875H3V19.625V9V7.125V4H7.0625V2.4375V1.5H8.9375V2.4375ZM4.875 9V19.625H18.625V9H4.875Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconCart = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M1.9375 2.5H4.75H5.49219L5.64844 3.28125L5.76562 3.75H21.5078H23.5L22.9141 5.625L20.375 13.75H7.64062L7.99219 15.625H20.0625H21V17.5H20.0625H7.25H6.46875L6.3125 16.7578L3.96875 4.375H1.9375H1V2.5H1.9375ZM7.28906 11.875H18.9688L20.9219 5.625H6.11719L7.28906 11.875ZM7.875 22.5C7.17188 22.5 6.58594 22.1484 6.23438 21.5625C5.88281 21.0156 5.88281 20.2734 6.23438 19.6875C6.58594 19.1406 7.17188 18.75 7.875 18.75C8.53906 18.75 9.125 19.1406 9.47656 19.6875C9.82812 20.2734 9.82812 21.0156 9.47656 21.5625C9.125 22.1484 8.53906 22.5 7.875 22.5ZM21 20.625C21 21.3281 20.6094 21.9141 20.0625 22.2656C19.4766 22.6172 18.7344 22.6172 18.1875 22.2656C17.6016 21.9141 17.25 21.3281 17.25 20.625C17.25 19.9609 17.6016 19.375 18.1875 19.0234C18.7344 18.6719 19.4766 18.6719 20.0625 19.0234C20.6094 19.375 21 19.9609 21 20.625Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconCheck = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M20.5 6.57812L19.8359 7.24219L9.91406 17.125L9.25 17.7891L8.58594 17.125L3.66406 12.2031L3 11.5391L4.28906 10.2109L4.95312 10.875L9.25 15.1328L18.5078 5.91406L19.1719 5.25L20.5 6.57812Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconChevronDown = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M12.6387 16.3359L11.9746 17L11.3105 16.3359L5.33398 10.3594L4.66992 9.69531L5.99805 8.36719L6.66211 9.03125L11.9746 14.3437L17.3262 9.03125L17.9902 8.36719L19.3184 9.69531L18.6543 10.3594L12.6387 16.3359Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconChevronLeft = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M7.66406 12.6187L7 11.9546L7.66406 11.2905L13.6406 5.31396L14.3047 4.6499L15.6328 5.97803L14.9688 6.64209L9.65625 11.9546L14.9687 17.3062L15.6328 17.9702L14.3047 19.2983L13.6406 18.6343L7.66406 12.6187Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconChevronRight = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M16.3359 11.3296L17 11.9937L16.3359 12.6577L10.3594 18.6343L9.69531 19.2983L8.36719 17.9702L9.03125 17.3062L14.3438 11.9937L9.03125 6.64209L8.36719 5.97803L9.69531 4.6499L10.3594 5.31396L16.3359 11.3296Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconChevronUp = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M11.3496 8.66406L12.0137 8L12.6777 8.66406L18.6543 14.6406L19.3184 15.3047L17.9902 16.6328L17.3262 15.9687L12.0137 10.6562L6.66211 15.9687L5.99805 16.6328L4.66992 15.3047L5.33398 14.6406L11.3496 8.66406Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconClose = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M7.41608 5.99991L18.0227 16.6065L16.6085 18.0207L6.00187 7.41412L7.41608 5.99991Z"
          fill="currentColor"
        ></path>
        <path
          d="M18.0215 7.41397L7.41495 18.0206L6.00073 16.6064L16.6073 5.99976L18.0215 7.41397Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconDownload = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.46973 12.6554L8.53039 11.5947L12.0001 15.0644L15.4697 11.5947L16.5304 12.6554L12.0001 17.1857L7.46973 12.6554Z"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.75 6.125V16.125H11.25V6.125H12.75Z"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.25 0.875H22.75V22.375H1.25V0.875ZM2.75 2.375V20.875H21.25V2.375H2.75Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconHamburger = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M3 5H20.5V6.875H3V5ZM3 11.25H20.5V13.125H3V11.25ZM20.5 17.5V19.375H3V17.5H20.5Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconInfo = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M18.625 4.875H4.875V18.625H18.625V4.875ZM4.875 3H18.625H20.5V4.875V18.625V20.5H18.625H4.875H3V18.625V4.875V3H4.875Z"
          fill="currentColor"
        ></path>
        <path d="M11.028 9.786H12.736V16.8H11.028V9.786ZM11 7H12.75V8.652H11V7Z" fill="currentColor"></path>
      </svg>
    )
  }),
)

export const IconLocation = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M17.125 9.5C17.125 6.41406 14.5859 3.875 11.5 3.875C8.375 3.875 5.875 6.41406 5.875 9.5C5.875 10.1641 6.14844 11.1406 6.8125 12.4688C7.47656 13.7188 8.33594 15.0469 9.23438 16.2969C10.0547 17.3906 10.8359 18.3672 11.5 19.1484C12.125 18.3672 12.9062 17.3906 13.7266 16.2969C14.625 15.0469 15.4844 13.7188 16.1484 12.4688C16.8125 11.1406 17.125 10.1641 17.125 9.5ZM19 9.5C19 12.7812 14.8594 18.0547 12.7109 20.5938C11.9688 21.4922 11.5 22 11.5 22C11.5 22 10.9922 21.4922 10.25 20.5938C8.10156 18.0547 4 12.7812 4 9.5C4 5.35938 7.35938 2 11.5 2C15.6406 2 19 5.35938 19 9.5ZM12.75 9.5C12.75 8.83594 12.1641 8.25 11.5 8.25C10.7969 8.25 10.25 8.83594 10.25 9.5C10.25 10.2031 10.7969 10.75 11.5 10.75C12.1641 10.75 12.75 10.2031 12.75 9.5ZM8.375 9.5C8.375 8.40625 8.96094 7.39062 9.9375 6.80469C10.875 6.25781 12.0859 6.25781 13.0625 6.80469C14 7.39062 14.625 8.40625 14.625 9.5C14.625 10.6328 14 11.6484 13.0625 12.2344C12.0859 12.7812 10.875 12.7812 9.9375 12.2344C8.96094 11.6484 8.375 10.6328 8.375 9.5Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconPlaceholder = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <circle cx="12" cy="12" r="7" fill="currentColor"></circle>
      </svg>
    )
  }),
)

export const IconPlay = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M5 3L6.875 4.09375L18.125 10.6953L20 11.75L18.125 12.8438L6.875 19.4062L5 20.5V18.3516V5.1875V3ZM6.875 6.28125V17.2578L16.25 11.75L6.875 6.28125Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconAdd = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M13.0625 4.9375V11.1875H19.3125H20.25V13.0625H19.3125H13.0625V19.3125V20.25H11.1875V19.3125V13.0625H4.9375H4V11.1875H4.9375H11.1875V4.9375V4H13.0625V4.9375Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconAccount = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M14.875 6.5C14.875 5.40625 14.25 4.39062 13.3125 3.80469C12.3359 3.25781 11.125 3.25781 10.1875 3.80469C9.21094 4.39062 8.625 5.40625 8.625 6.5C8.625 7.63281 9.21094 8.64844 10.1875 9.23438C11.125 9.78125 12.3359 9.78125 13.3125 9.23438C14.25 8.64844 14.875 7.63281 14.875 6.5ZM6.75 6.5C6.75 4.74219 7.6875 3.10156 9.25 2.20312C10.7734 1.30469 12.6875 1.30469 14.25 2.20312C15.7734 3.10156 16.75 4.74219 16.75 6.5C16.75 8.29688 15.7734 9.9375 14.25 10.8359C12.6875 11.7344 10.7734 11.7344 9.25 10.8359C7.6875 9.9375 6.75 8.29688 6.75 6.5ZM5.53906 19.625H17.9609L16.5938 15.25H6.86719L5.53906 19.625ZM5.5 13.375H18L19.9141 19.625L20.5 21.5H18.5078H4.95312H3L3.54688 19.625L5.5 13.375Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconSearch = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M16.375 10.625C16.375 8.39844 15.1641 6.36719 13.25 5.23438C11.2969 4.10156 8.91406 4.10156 7 5.23438C5.04688 6.36719 3.875 8.39844 3.875 10.625C3.875 12.8906 5.04688 14.9219 7 16.0547C8.91406 17.1875 11.2969 17.1875 13.25 16.0547C15.1641 14.9219 16.375 12.8906 16.375 10.625ZM15.1641 17.0312C13.7578 18.125 12 18.75 10.125 18.75C5.63281 18.75 2 15.1172 2 10.625C2 6.17188 5.63281 2.5 10.125 2.5C14.5781 2.5 18.25 6.17188 18.25 10.625C18.25 12.5391 17.5859 14.2969 16.4922 15.7031L21.3359 20.5469L22 21.2109L20.6719 22.5L20.0078 21.8359L15.1641 16.9922V17.0312Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconSelectNo = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconSelectYes = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z"
          fill="currentColor"
        ></path>
        <path
          d="M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconTicket = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5987 5.5C14.0799 6.3967 13.1104 7 12 7C10.8896 7 9.92006 6.3967 9.40135 5.5H7.5V18.5H9.40135C9.92006 17.6033 10.8896 17 12 17C13.1104 17 14.0799 17.6033 14.5987 18.5H16.5V5.5H14.5987ZM13.5 20C13.5 19.1716 12.8284 18.5 12 18.5C11.1716 18.5 10.5 19.1716 10.5 20H6V4H10.5C10.5 4.82843 11.1716 5.5 12 5.5C12.8284 5.5 13.5 4.82843 13.5 4H18V20H13.5Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export type IconName =
  | "arrowLeft"
  | "arrowRight"
  | "bookmark"
  | "calendar"
  | "cart"
  | "check"
  | "chevronDown"
  | "chevronLeft"
  | "chevronRight"
  | "chevronUp"
  | "close"
  | "download"
  | "hamburger"
  | "info"
  | "location"
  | "placeholder"
  | "play"
  | "add"
  | "account"
  | "search"
  | "selectNo"
  | "selectYes"
  | "ticket"

type IconProps = Omit<SVGProps, "name"> & { name: IconRef | undefined }
type IconComponent = (props: SVGProps) => ReactElement
type IconSet = { [K in IconName]: IconComponent }

export const ICONS = {
  arrowLeft: IconArrowLeft,
  arrowRight: IconArrowRight,
  bookmark: IconBookmark,
  calendar: IconCalendar,
  cart: IconCart,
  check: IconCheck,
  chevronDown: IconChevronDown,
  chevronLeft: IconChevronLeft,
  chevronRight: IconChevronRight,
  chevronUp: IconChevronUp,
  close: IconClose,
  download: IconDownload,
  hamburger: IconHamburger,
  info: IconInfo,
  location: IconLocation,
  placeholder: IconPlaceholder,
  play: IconPlay,
  add: IconAdd,
  account: IconAccount,
  search: IconSearch,
  selectNo: IconSelectNo,
  selectYes: IconSelectYes,
  ticket: IconTicket,
} as IconSet

export type IconRef = IconName | ReactElement

export function Icon(props: IconProps) {
  if (!props.name) return null
  if (isValidElement(props.name)) {
    return props.name
  }
  const { name, ...rest } = props
  if (typeof name === "string" && name in ICONS) {
    const IconComponent = ICONS[name]
    return <IconComponent className="icon" {...rest} />
  }
  return props.name
}
